<template>
  <form
    class="search-bar"
    :class="{ 'search-bar--transparent': isTransparentHeader }"
    :action="$variable('routes.search')"
    method="GET"
  >
    <label
      class="visually-hidden"
      for="header-search"
      v-text="$string('general.site_header.search_placeholder')"
    />

    <input
      id="header-search"
      class="
        search-bar__input
        text-body-m-regular
      "
      name="q"
      :placeholder="$string('general.site_header.search_placeholder')"
      type="search"
      autocomplete="off"
      @input="handleInputChange"
    >

    <button
      class="
        search-bar__submit
        icon-button
      "
      type="submit"
    >
      <span
        class="visually-hidden"
        v-text="$string('general.site_header.search')"
      />

      <icon-search />
    </button>
  </form>
</template>

<script>

/**
 * Vue: Search bar (search-bar)
 * -----------------------------------------------------------------------------
 * Search bar used in the header.
 *
 * @param {Boolean} [isTransparentHeader] - Is the header transparent on that
 * current page.
 *
 */
import IconSearch from '~icons/general/search.svg'

export default {
  name: 'SearchBar',

  components: {
    IconSearch,
  },

  props: {
    isTransparentHeader: {
      type: Boolean,
      default: false,
    },
  },

  emits: {
    'update-search-query': (payload) => typeof payload === 'string',
  },

  methods: {

    /**
     * Handles the input event on the search input.
     * @param {Object} event - Input event.
     */
    handleInputChange(event) {
      const value = event.target.value

      this.emitSearchQuery(value)
    },

    /**
     * Emit search state.
     * @param {String} query - Search dropdown query string.
     */
    emitSearchQuery(query) {
      this.$emit('update-search-query', query)
    },
  },
}
</script>

<style lang="scss">
@import './search-bar';
</style>
